import UserElevatorIntegrationSettings from './UserElevatorIntegrationSettings';

export default UserElevatorIntegrationSettings;
